/**
 * @method getPercentageOfDocumentForElement
 */
const getPercentageOfDocumentForElement = (frame, element) => {
  if (!element) {
    throw new Error('element is required');
  }

  const activeContainer = frame.parentElement;
  const frameParent = activeContainer.parentElement;

  const elementTop = element.getBoundingClientRect().top;
  const comparedToHeight = frameParent.scrollHeight - frameParent.offsetHeight;

  if (comparedToHeight === 0) {
    return 0;
  }

  const percentageOfDocument = elementTop / comparedToHeight;

  return percentageOfDocument;
};

export default getPercentageOfDocumentForElement;
